// 巡检上地图 相关请求
import req from './index'

//获取管线
export const getGodMapIndexInfo = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.RoutesListTop_Get', params)
}

//获取航点
export const GetRoutesPoint = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.RoutesPoint_Get', params)
}
//获取航点以及航点动作
export const GetRoutesPointAction = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.RoutesPointAction_Get', params)
}
//获取管线详细信息 包括起飞点
export const GetRoutesInfo = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.RoutesInfo_Get', params)
}